window.dataLayer = window.dataLayer || [];

/**
 * Wrapper for dataLayer Object used for tracking
 *
 * @param {String} eventName The name of the event to track
 * @returns {Object} dataLayer object push result
 */
function dataLayer(eventName) {
  return window.dataLayer.push({event: eventName});
}

export default dataLayer;
